const appUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;

//to avoid eslint rules notification
const authenticationServiceSettings = {};
authenticationServiceSettings["authority"] = process.env.REACT_APP_AUTH_AUTHORITY;
authenticationServiceSettings["client_id"] = process.env.REACT_APP_AUTH_CLIENT_ID;
authenticationServiceSettings["redirect_uri"] = `${appUrl}/signedin`;
authenticationServiceSettings["response_type"] = "id_token token";
authenticationServiceSettings["scope"] = process.env.REACT_APP_AUTH_SCOPE;
authenticationServiceSettings["monitorSession"] = false;

if (process.env.REACT_APP_AUTH_LOCAL_METADATA === "1") {
  const metadata = {};
  metadata["issuer"] = process.env.REACT_APP_AUTH_ISSUER;
  metadata["authorization_endpoint"] = process.env.REACT_APP_AUTH_ENDPOINT;
  metadata["token_endpoint"] = process.env.REACT_APP_AUTH_TOKEN_ENDPOINT;
  metadata["userinfo_endpoint"] = process.env.REACT_APP_AUTH_USER_INFO_ENDPOINT;
  metadata["end_session_endpoint"] = process.env.REACT_APP_AUTH_END_SESSION_ENDPOINT;
  metadata["jwks_uri"] = process.env.REACT_APP_AUTH_JWKURI;
  authenticationServiceSettings["metadata"] = metadata;
}

export const authentication = {
  authenticationServiceSettings: authenticationServiceSettings
};
